import { render } from "./DataBoxes.vue?vue&type=template&id=3da226b1"
import script from "./DataBoxes.vue?vue&type=script&lang=ts"
export * from "./DataBoxes.vue?vue&type=script&lang=ts"
script.render = render

export default script